import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import WalletAPIDark from "@/common/assets/image/products/icons/WalletAPIDark.svg"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"

const WalletAPIPage = () => {
  const { t } = useTranslation(["walletAPI"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/wallet-api"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/wallet-api"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/wallet-api"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/wallet-api"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={WalletAPIDark.src}
          bannerType={ProductNames.WalletAPI}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
        />
        <SectionLine />
        <Description
          items={[
            {
              titles: [{ text: t("Desc.1.title") }],
              content: t("Desc.1.content")
            },
            {
              titles: [{ text: t("Desc.2.title") }],
              content: t("Desc.2.content")
            },
            {
              titles: [{ text: t("Desc.3.title") }],
              content: t("Desc.3.content")
            }
          ]}
        />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.description")}
          primaryButton={{ text: t("CTA.button1") }}
          secondaryButton={{
            text: t("CTA.button2"),
            href: "https://www.kryptogo.com/docs/wallet-api/getting-started"
          }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.WalletBuilder,
                ProductNames.WalletApplication
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "walletAPI"
    ]))
  }
})

export default WalletAPIPage
